import type { PhotoInterface } from '@valk-nx/core/lib/interfaces/image.interface';
import type {
	BynderImage,
	CarouselItem,
	ISbStoryBlok,
} from '@valk-nx/storyblok-types/src/lib/types/storyblok.interface';

interface CarouselLikeBlok {
	items?: CarouselItem[];
	blocks?: CarouselLikeBlok[];
}

/**
 * Extracts all carousel images (src + alt) from Storyblok carousel bloks.
 *
 * Supports both `carousel` bloks (items directly on the blok) and
 * `carouselWithAvailabilityWidget` bloks (items nested in `blocks`).
 * Items without a bynder image (e.g. video-only items) are skipped.
 */
export function extractCarouselImages(bloks: ISbStoryBlok[]): PhotoInterface[] {
	return bloks
		.flatMap((blok) => collectCarouselItems(blok as CarouselLikeBlok))
		.filter(hasBynderImage)
		.map((item) => ({
			src: item.bynder[0].files.transformBaseUrl.url,
			alt: item.imageAlt,
		}));
}

function hasBynderImage(
	item: CarouselItem,
): item is CarouselItem & { bynder: BynderImage[] } {
	return Boolean(item.bynder?.[0]);
}

function collectCarouselItems(blok: CarouselLikeBlok): CarouselItem[] {
	if (blok.items) {
		return blok.items;
	}

	if (!blok.blocks) {
		return [];
	}

	return blok.blocks.flatMap(collectCarouselItems);
}
